/* Fabrikone guide links: no cart writes, price changes or network requests. */
(() => {
  'use strict';
  if (window.FabrikoneGuideAccess) { window.FabrikoneGuideAccess.init(); return; }
  const state = new Map();
  let guides = [];
  try { guides = JSON.parse(document.querySelector('[data-fgr-catalog]')?.textContent || '[]'); } catch (_) {}
  const safeURL = value => { try { const u = new URL(value, location.origin); return u.origin === location.origin && /^https?:$/.test(u.protocol) ? u.href : ''; } catch (_) { return ''; } };
  guides = guides.filter(g => typeof g.key === 'string' && typeof g.title === 'string' && safeURL(g.url));
  const guideMap = new Map(guides.map(g => [g.key, g]));
  const pathKey = value => { try { const u = new URL(value, location.origin); return u.origin === location.origin ? decodeURIComponent(u.pathname).normalize('NFC').replace(/\/$/, '') : ''; } catch (_) { return ''; } };
  const keysFor = key => {
    const primary = {fragrance:'fragrance',gel_fragrance:'gel',dye:'dye',dye_metallic:'dye',wick:'wick',container:'jar',equipment:'temperature',leaf:'jar',pillar:'mold',gel:'gel',beeswax:'beeswax',cream:'cream',creamy:'cream'}[key] || 'temperature';
    return [...new Set([primary, 'fragrance', 'dye'])].filter(k => guideMap.has(k));
  };
  function links(parent, keys) {
    if (!parent) return;
    const selected = [...new Set(keys)].map(k => guideMap.get(k)).filter(Boolean);
    const signature = selected.map(g => g.key).join('|');
    let box = [...parent.children].find(n => n.hasAttribute('data-fgr-links'));
    if (!selected.length) { box?.remove(); return; }
    if (box && box.dataset.fgrLinks === signature) return;
    if (!box) { box = document.createElement('nav'); box.className = 'fgr-card-links'; box.setAttribute('aria-label','İlgili kullanım rehberleri'); box.setAttribute('data-fgr-owned',''); parent.append(box); }
    box.dataset.fgrLinks = signature;
    box.replaceChildren();
    const note = document.createElement('small'); note.textContent = 'Projende kullanmadan önce · yeni sekmede açılır'; box.append(note);
    for (const g of selected) {
      const a = document.createElement('a'); a.href = safeURL(g.url); a.target = '_blank'; a.rel = 'noopener'; a.textContent = g.title + ' ↗'; a.setAttribute('aria-label', g.title + ' — yeni sekmede açılır'); box.append(a);
    }
  }
  function catalogIndex(root, selector) {
    let blocks = [];
    try { blocks = JSON.parse(root.querySelector(selector)?.textContent || '[]'); } catch (_) {}
    const byId = new Map(), byPath = new Map(), byBlock = new Map();
    for (const b of blocks) {
      byBlock.set(String(b.id), b);
      for (const p of b.products || []) {
        const entry = {product:p, key:b.key};
        byId.set(String(p.id), entry); byPath.set(pathKey(p.url), entry);
      }
    }
    return {byId,byPath,byBlock};
  }
  function matchingLink(box, index) {
    for (const a of box.querySelectorAll('a[href]')) {
      if (a.closest('[data-fgr-owned]')) continue;
      const entry = index.byPath.get(pathKey(a.getAttribute('href')));
      if (entry) return entry;
    }
    return null;
  }
  function planner(root, index) {
    root.querySelectorAll('.fp-pack,.fp-plan-product,.fp-shopping-table td:nth-child(3),[data-dialog-body] li').forEach(card => {
      const entry = matchingLink(card,index); if (entry) links(card, keysFor(entry.key));
    });
    root.querySelectorAll('.fp-var-card').forEach(card => {
      const entry = [...card.querySelectorAll('select')].map(s => index.byId.get(s.value)).find(Boolean);
      if (entry) links(card, keysFor(entry.key));
    });
    root.querySelectorAll('[data-family-card]').forEach(card => {
      const family = index.byBlock.get(card.dataset.familyCard);
      if (family) links(card, keysFor(family.key));
    });
    const scent = root.querySelector('[name="fragrance"]')?.closest('details');
    if (scent) links(scent, keysFor('fragrance'));
    const dye = root.querySelector('[data-dye-note]');
    if (dye && !root.querySelector('[data-fgr-dye-selection]')) {
      const box = document.createElement('div'); box.setAttribute('data-fgr-dye-selection',''); box.setAttribute('data-fgr-owned',''); dye.after(box); links(box, keysFor('dye'));
    }
    root.querySelectorAll('[data-tool]').forEach(input => {
      const entry = index.byId.get(input.dataset.tool), label = input.closest('label');
      if (!entry || !label) return;
      let wrap = label.parentElement;
      if (!wrap.hasAttribute('data-fgr-tool')) {
        wrap = document.createElement('div'); wrap.setAttribute('data-fgr-tool',''); wrap.className='fgr-tool'; label.before(wrap); wrap.append(label);
      }
      links(wrap, keysFor('equipment'));
    });
  }
  function studio(root, index) {
    root.querySelectorAll('[data-materials] > .fst-material').forEach((card, i) => {
      const row = root.rows?.[i];
      const p = row?.plan?.variant?.product || row?.candidates?.[0]?.product;
      const entry = p && index.byId.get(String(p.id));
      const body = card.querySelector('.fst-material-body');
      if (row) links(body,keysFor(entry?.key || (row.kind==='wax' ? root.form?.elements.namedItem('family')?.value : row.kind)));
    });
    root.querySelectorAll('.fst-choice').forEach(card => {
      const entry = matchingLink(card,index);
      if (entry) links(card.querySelector('h3')?.parentElement || card,keysFor(entry.key));
    });
    root.querySelectorAll('[data-tools] > label').forEach((label,i) => {
      const tool = root.tools?.[i]; if (!tool) return;
      const wrap = document.createElement('div'); wrap.setAttribute('data-fgr-tool',''); wrap.className='fgr-tool'; label.before(wrap); wrap.append(label); links(wrap,keysFor('equipment'));
    });
    const mix = root.querySelectorAll('.fst-step')[3];
    if (mix) links(mix.querySelector('h3')?.parentElement, ['fragrance','dye']);
  }
  function technical(root) {
    root.querySelectorAll('[data-tech-item]').forEach(card => {
      const body = card.querySelector('[data-tech-price]')?.parentElement || card.querySelector('select')?.parentElement || card;
      links(body,['fragrance','dye']);
    });
  }
  function product(root) {
    const panel = root.querySelector('[data-fgr-product]');
    if (!panel) return;
    const buy = root.querySelector('.buy-buttons-block');
    if (buy && !root.querySelector('[data-fgr-buy-link]')) {
      const a = document.createElement('a'); a.href = '#' + panel.id; a.className='fgr-purchase-link'; a.setAttribute('data-fgr-owned',''); a.setAttribute('data-fgr-buy-link',''); a.textContent = 'Esans ve toz boya kullanımını öğren ↓'; buy.after(a);
    }
  }
  function initRoot(root) {
    if (state.has(root)) return;
    const index = catalogIndex(root, root.matches('fab-studio') ? '[data-catalog]' : '[data-fp-catalog]');
    let timer = 0, disposed = false;
    const observer = new MutationObserver(() => schedule());
    const run = () => {
      timer=0; if (disposed || !root.isConnected) return;
      observer.disconnect();
      try {
        if (root.matches('[data-fp]')) planner(root,index);
        else if (root.matches('fab-studio')) studio(root,index);
        else if (root.matches('[data-fab-tech-page]')) technical(root);
        else product(root);
      } finally { if (!disposed) observer.observe(root,{childList:true,subtree:true}); }
    };
    const schedule = () => { if (!timer && !disposed) timer=setTimeout(run,0); };
    root.addEventListener('change', schedule);
    run();
    state.set(root,() => { disposed=true;clearTimeout(timer);observer.disconnect();root.removeEventListener('change',schedule);state.delete(root); });
  }
  function init() {
    document.querySelectorAll('[data-fp],fab-studio,[data-fab-tech-page],product-info').forEach(initRoot);
  }
  function closeMenus(event) {
    document.querySelectorAll('[data-fgr-menu][open]').forEach(d => { if (!d.contains(event.target)) d.open=false; });
  }
  document.addEventListener('click', e => {
    closeMenus(e);
    const link=e.target.closest('a[href]');
    if (!link || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    const u = new URL(link.href,location.origin);
    if (u.origin===location.origin && u.hash==='#fba-rehberler') {
      const menu=document.querySelector('[data-fgr-menu]');
      if(menu){
        e.preventDefault();
        const openGuides=()=>{const header=menu.closest('[data-fabrikone-header]');header?.removeAttribute('data-compact');const row=menu.closest('.fgh__nav-row');if(row)row.inert=false;menu.open=true;menu.querySelector('summary').focus();};
        const collections=link.closest('fab-collections-menu'), dialog=collections?.querySelector('dialog[open]');
        if(dialog && typeof collections.close==='function'){dialog.addEventListener('close',openGuides,{once:true});collections.close(false);}
        else openGuides();
      }
    }
    if(link.closest('[data-fgr-menu]'))link.closest('[data-fgr-menu]').open=false;
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('[data-fgr-menu][open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});});
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',e=>{for(const [root,cleanup] of state)if(e.target.contains(root))cleanup();});
  window.FabrikoneGuideAccess={init};
  init();
  if (document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
})();
